/**
 * Component: Modal
 * ------------------------------------------------------------------------------
 * Instantiate Micromodal and configure defaults across modal components.
 * - https://micromodal.now.sh/#configuration
 *
 * @namespace Modal
 */

import log from 'salvo-lite/log'

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import * as a11y from '@shopify/theme-a11y'

import MicroModal from '../vendors/micromodal'

class Modal {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem

        /**
         * Instance events.
         */
        this._eventSelector = {
            modalClose: 'Modal:Close',
            modalShow: 'Modal:Show'
        }

        /**
         * DOM selectors.
         */
        this._selectors = {
            body: '[js-modal="body"]'
        }

        /**
         * Instance globals.
         */
        this._modal = MicroModal

        /**
         * Instance default settings.
         */
        this._settings = {
            awaitCloseAnimation: true,
            ...JSON.parse(elem.getAttribute('data-modal') || '{}')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Instantiate a new modal.
     */
    onInit () {
        this._modal.init({
            onShow: (container) => this._onShowCallback(container.id),
            onClose: (container) => this._onCloseCallback(container.id)
        })

        this._unsetTabIndexOnContainer(this._settings.id)
        this._setEventBusListeners()
    }

    /**
     * Set event bus listeners.
     */
    _setEventBusListeners () {
        window.Frame.EventBus.listen(`${this._eventSelector.modalShow}:${this._settings.id}`, (element) => {
            disableBodyScroll(element.querySelector(this._selectors.body))
        })

        window.Frame.EventBus.listen(`${this._eventSelector.modalClose}:${this._settings.id}`, (element) => {
            enableBodyScroll(element.querySelector(this._selectors.body))
            clearAllBodyScrollLocks()
        })
    }

    /**
     * Force show the modal instance.
     * @param {String} id - Modal container id.
     */
    _show () {
        console.log(this._modal)
        console.log(this._settings.id)
        this._modal.show(this._settings.id)
    }

    /**
     * Force close the modal instance.
     * @param {String} id - Modal container id.
     */
    _close () {
        this._modal.close(this._settings.id)
    }

    /**
     * Show modal with default settings.
     * @param {String} id - Modal container id.
     */
    _onShowCallback () {
        this._setTabIndexOnContainer()
    }

    /**
     * Close modal with default settings.
     * @param {String} id - Modal container id.
     */
    _onCloseCallback () {
        this._unsetTabIndexOnContainer()
    }

    /**
     * Unset tabindex to 0 to make them un-tabbable.
     * @param {String} id - Modal container id.
     */
    _unsetTabIndexOnContainer () {
        const focusable = a11y.focusable(this._elem)
        focusable.forEach((element) => element.setAttribute('tabindex', -1))
    }

    /**
     * Unset tabindex to 1 to make them tabbable.
     * @param {String} id - Modal container.
     */
    _setTabIndexOnContainer () {
        const focusable = a11y.focusable(this._elem)
        focusable.forEach((element) => element.setAttribute('tabindex', 0))
    }

    /**
     * Get container based on id.
     * @param {String} id - Modal container id.
     */
    _getContainerById (id) {
        if (typeof id !== 'string') {
            throw new Error('Must be a valid string id')
        }
        return document.getElementById(id)
    }

    // /**
    //  * Expose public interface.
    //  */
    // return Object.freeze({
    //     init,
    //     show,
    //     close,
    // })
}

export default Modal



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Modal.js